import Cookies from 'js-cookie';

export const extractDomain = (): string => {
  if (typeof window === "undefined") return "";

  const currentOrigin = window.location.origin;

  if (
    currentOrigin.includes("localhost:3000") ||
    currentOrigin.includes("test")
  ) {
    return "https://recruiter.foundit.in";
  }

  return currentOrigin;
};

export const getDomainName = (hostname: string) => {
  let newDomainName = hostname?.replace(/^recruiter\./, "");
  if (hostname === "localhost") {
    newDomainName = "foundit.in";
  }
  return newDomainName;
};

export function extractBaseServer(url: string) {
  if (url.includes("localhost") || url.includes("test")) {
    url = "recruiter.foundit.in";
  }

  const parts = url.split(".");
  const domain = parts[parts.length - 2] + "." + parts[parts.length - 1];

  return domain;
}

// clear session and cookies
export const clearSessionAndCookieItem = (key:any) => {
    sessionStorage.removeItem(key);
    // delete cookie
    Cookies.remove(key, { path: '/' })
}

export const API_HEADERS = {
  domain: extractDomain(),
};

export const MIDDLEWARE = "/edge/recruiter-dashboard/api/dashboard-middleware";


